export default __webpack_public_path__ + "static/section_3_details_2-8aa3262b76ce7856ed708e0522275eaa.png";